import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/ds-utils.js";
import "moment-timezone";
import "validator/es/lib/isEmail";
import { cva } from "class-variance-authority";
const CardsVariantContext = React.createContext("outline");
const cardVariants = cva(
  "flex flex-col bg-card text-card-foreground",
  {
    variants: {
      variant: {
        outline: "rounded-xl border transition-all hover:shadow-xs",
        plain: ""
      }
    },
    defaultVariants: {
      variant: "outline"
    }
  }
);
const Card = React.forwardRef(({ variant = "outline", className, ...props }, ref) => /* @__PURE__ */ jsx(CardsVariantContext.Provider, { value: variant, children: /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn(cardVariants({ variant, className })),
    ...props
  }
) }));
Card.displayName = "Card";
const cardHeaderVariants = cva(
  "flex flex-col gap-y-1.5",
  {
    variants: {
      variant: {
        outline: "p-6",
        plain: "border-b py-5"
      }
    },
    defaultVariants: {
      variant: "outline"
    }
  }
);
const CardHeader = React.forwardRef(({ className, ...props }, ref) => {
  const variant = React.useContext(CardsVariantContext);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: cn(cardHeaderVariants({ variant, className })),
      ...props
    }
  );
});
CardHeader.displayName = "CardHeader";
const CardTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("tracking-tight font-semibold leading-none", className),
    ...props
  }
));
CardTitle.displayName = "CardTitle";
const CardDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("text-sm text-muted-foreground", className),
    ...props
  }
));
CardDescription.displayName = "CardDescription";
const cardContentVariants = cva(
  "",
  {
    variants: {
      variant: {
        outline: "p-6 pt-0",
        plain: "border-b"
      }
    },
    defaultVariants: {
      variant: "outline"
    }
  }
);
const CardContent = React.forwardRef(({ className, ...props }, ref) => {
  const variant = React.useContext(CardsVariantContext);
  return /* @__PURE__ */ jsx("div", { ref, className: cn(cardContentVariants({ variant, className })), ...props });
});
CardContent.displayName = "CardContent";
const cardFooterVariants = cva(
  "flex w-full items-center",
  {
    variants: {
      variant: {
        outline: "p-6 pt-0",
        plain: "py-5"
      }
    },
    defaultVariants: {
      variant: "outline"
    }
  }
);
const CardFooter = React.forwardRef(({ className, ...props }, ref) => {
  const variant = React.useContext(CardsVariantContext);
  return /* @__PURE__ */ jsx("div", { className: "flex grow items-end", children: /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: cn(cardFooterVariants({ variant, className })),
      ...props
    }
  ) });
});
CardFooter.displayName = "CardFooter";
const EmptyCard = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("p-6 transition-all hover:shadow-xs rounded-xl border flex flex-col bg-card text-card-foreground", className),
    ...props
  }
));
EmptyCard.displayName = "EmptyCard";
export {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  EmptyCard,
  cardVariants
};
//# sourceMappingURL=card.js.map
